import React, {useEffect} from "react";
const blogs = [
  {
    name: "ac",
    blog:
      "Our AC service price has been designed by the expert professional by keeping in mind the customer budget and requirements.\n" +
      "AC Service: Importance Of AC Service\n" +
      "\n" +
      "Although there are various benefits of AC service, here are the few crucial points that will help you know my AC service is essential.\n" +
      "1. AC Service- Maintain Air Conditioner Efficiency \n" +
      "\n" +
      "Being one of the electronic home appliances, an air conditioner demands regular AC service. Several experts say that getting AC service done is crucial to maintain the AC unit's efficiency and productivity.\n" +
      "2. Removal of Excess of Dirt\n" +
      "\n" +
      "Like everything at our home needs to be cleaned regularly, why should the AC unit be discriminated against? Although these appliances do not need cleaning every day, they do require cleaning at least once at each 3 months interval.\n" +
      "give your AC dry service regularly or at least once every 3 months to avoid living in such unhealthy air. As most of our time is spent indoors, our health is directly proportionate to the indoor air quality, which needs to be taken ultra-care about.\n" +
      "3. Less Energy Consumption\n" +
      "\n" +
      "Do you feel disturbed when you end up paying a huge electricity bill, especially during summers? So if you want to know what the solution to this everlasting problem is. The answer is fundamental, which is: Regular AC service and repair. Cleaning up the AC and fixing all its operations helps in reducing the energy consumption of the AC. Lower use of energy direct reduced electricity rates.  Home AC service cost is the very bare minimum, and if done regularly, it does help you save a lot of extra fees.",
  },
  { name: "Carpentery", blog: "" },
  { name: "Plumbing", blog: "" },
  { name: "Tv", blog: "" },
  { name: "Fridge", blog: "" },
  { name: "ro/filter", blog: "" },
  { name: "Microwave", blog: "" },
  { name: "Washing Machine", blog: "" },
  { name: "Electrician", blog: "" },
];
export default function ({ category }) {

const blog = blogs.filter((data)=>{
  return data.name === category
});

  console.log(blog)

  return (
    <>
      <h4>About {category}</h4>
      <p>{blog[0].blog}</p>
    </>
  );
}
